import axios from "axios";

export const SayanAxiosInstance = axios.create({
  baseURL: "https://test.kayan-healthcare.com/api/ksa/",
});
